import React, { forwardRef } from 'react';

type InputTypes = React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
> & {
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
    type: 'text' | 'number' | 'email' | 'password' | 'tel' | 'url';
    name: string;
    label?: string;
    description?: string;
    fieldStyles?: {};
    isInvalid?: boolean;
    validationMessage?: string;
    hint?: string;
};

type Ref = HTMLInputElement;

export const Input = forwardRef<Ref, InputTypes>(
    (
        {
            type = 'text',
            name,
            label = '',
            description = '',
            hint = '',
            fieldStyles = { margin: '10px 0' },
            isInvalid = false,
            validationMessage = '',
            onChange,
            ...props
        },
        ref
    ) => {
        return (
            <div style={fieldStyles}>
                <label className="form-field-label" htmlFor={name}>
                    {label}
                </label>
                {description ? <span className="form-field-description">{description}</span> : null}
                <input
                    type={type}
                    className="form-field-input"
                    style={isInvalid ? { border: '1px solid var(--red)' } : {}}
                    id={name}
                    name={name}
                    {...props}
                    onChange={onChange}
                    ref={ref}
                />
                <span className="form-field-hint">{hint}</span>
                <span className="form-field-validation-message">{validationMessage}</span>
            </div>
        );
    }
);
